import React, { useEffect, useRef, useState } from 'react';
import config from '../config';

const FLayPriesBox = ({
  runner,
  value,
  checkMaxOdds,
  validation,
  getLock,
  handleOnBackClick,
}) => {
  const [highlighted, setHighlighted] = useState(['']);
  const prevPricesRef = useRef([
    { price: null, size: null }
  ]);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      for (let i = 0; i < 3; i++) {
        prevPricesRef.current[i] = {
          price: runner.layPrices?.[i]?.price,
          size: runner.layPrices?.[i]?.size,
        };
      }
      return;
    }

    const newHighlights = ['', '', ''];

    for (let i = 0; i < 3; i++) {
      const current = runner.layPrices?.[i];
      const prev = prevPricesRef.current[i];

      if (current?.price !== prev?.price || current?.size !== prev?.size) {
        if (current?.price > prev?.price) {
          newHighlights[i] = 'highlight-green';
        } else if (current?.price < prev?.price) {
          newHighlights[i] = 'highlight-red';
        }

        prevPricesRef.current[i] = { price: current?.price, size: current?.size };

        setTimeout(() => {
          setHighlighted((prev) => {
            const updated = [...prev];
            updated[i] = '';
            return updated;
          });
        }, 500);
      }
    }

    setHighlighted(newHighlights);
  }, [runner.layPrices]);

    const formatNumberNotFiex = (num) => {
    if (num >= 10000000) {
       return (num / 10000000).toFixed(2) + 'Cr'; // Crore
    } else if (num >= 100000) {
       return (num / 100000).toFixed(2) + 'L'; // Lakh
    } else if (num >= 1000) {
       return (num / 1000).toFixed(2) + 'K'; // Thousand
    } else {
       return num.toString(); // Less than 1000
    }
 };

  const dataSet = (price,size) =>{
    return(
      <>
      {validation(price) ? <span className='market-odd'>{price}</span> : getLock()}
      {validation(price) ? <small className='market-volume'>{formatNumberNotFiex(size)}</small> : ''}
      </>
    )
  }

  return (
    <>
      {[0].map((i) => {
        const price = runner.layPrices?.[i]?.price ?? 0;
        const size = runner.layPrices?.[i]?.line ?? 0;
        const boxValue = runner.layPrices?.[i];
        const disabled = checkMaxOdds(value?.marketId, price);

        return (
          <span
            key={i}
            className={`market-odd-box lay${i === 0 ? '' :i} ${disabled ? '' : 'disable'} ${highlighted[i]}`}
            onClick={() =>validation(price) ?
              handleOnBackClick(runner, config.lay, value.marketId, price, config.FANCY, value) :''
            }
          >
            {validation(price) ? dataSet(price,size) : getLock()}
          </span>
        );
      })}
    </>
  );
};

export default FLayPriesBox;
